import { Badge } from '@@/ui/primitives';
import clsx from 'clsx';

interface BooleanViewerProps {
  value: boolean;
}

export function BooleanViewer({ value }: BooleanViewerProps) {
  return (
    <Badge
      variant='outline'
      className={clsx(
        'text-xs',
        value ? 'text-green-950 bg-green-50 border-green-200' : 'text-red-950 bg-red-50 border-red-200'
      )}
    >
      {value ? 'True' : 'False'}
    </Badge>
  );
}
